import React from 'react';

import { AddNewDomainDialogInformation } from './AddNewDomainDialogInformation';
import { AddNewDomainTextField, AddNewDomainTextFieldProps } from './AddNewDomainTextField';
import { DomainPermissionsSelector, DomainPermissionsSelectorProps } from './DomainPermissionsSelector';
import { PoolAssignmentTextProps } from './PoolAssignmentText';

export type AddNewDomainDialogBodyProps = DomainPermissionsSelectorProps & PoolAssignmentTextProps & AddNewDomainTextFieldProps;

export function AddNewDomainDialogBody(props: AddNewDomainDialogBodyProps) {
    return (
        <>
            <AddNewDomainDialogInformation />
            <AddNewDomainTextField onDomainNameChange={props.onDomainNameChange} domainName={props.domainName} domainValidationStatus={props.domainValidationStatus} />
            <DomainPermissionsSelector onDomainPermissionChange={props.onDomainPermissionChange} domainPermission={props.domainPermission} />
        </>
    );
}
